const rules = {
  dateOfBirth: [
    { required: true, validator: (rule, value, callback) => {
        if(value) {
          let date = new Date();
          let bornDate = new Date(value);
          date.setFullYear(date.getFullYear() - 18);
          if(bornDate >= date)
            return callback(new Error('Вам не исполнилось 18 лет'));
          date = new Date();
          date.setFullYear(date.getFullYear() - 60);
          if(bornDate <= date)
            return callback(new Error('Вам больше 60 лет'));
          return callback();
        } else
          return callback(new Error('Пожалуйста, введите дату рождения'));
      }, trigger: 'change'}
  ],
  citizenship: [
    { required: true, validator: (rule, value, callback) => {
        if(value) {
          if(value != 'RU')
            return callback(new Error('Гражданство должно быть "Российская Федерация"'));
          return callback();
        } else
          return callback(new Error('Пожалуйста, выберите гражданство'));
      }, trigger: 'change'}
  ]
};
const educationRules = {
  activity: [
    { required: true, message: 'Пожалуйста, введите направление деятельности', trigger: 'change' }
  ],
  speciality: [
    { required: true, message: 'Пожалуйста, введите специальность', trigger: 'change'}
  ],
  qualification: [
    { required: true, message: 'Пожалуйста, введите квалификацию', trigger: 'blur' }
  ],
  dateFinish: [
    { required: true, validator: (rule, value, callback) => {
        if(value) {
          let fromDate = new Date();
          let toDate = new Date();
          let finishDate = new Date(value);
          fromDate.setFullYear(fromDate.getFullYear() - 44);
          if(!(finishDate >= fromDate && finishDate <= toDate)) {
            var dateFormat = require('dateformat');
            return callback(new Error('Дата окончания должна быть в промежутке от '+ dateFormat(fromDate, 'dd.mm.yyyy') + ' до ' + dateFormat(toDate, 'dd.mm.yyyy')));
          }
          return callback();
        } else
          return callback(new Error('Пожалуйста, введите дату окончания'));
      }, trigger: 'change' }
  ],
  type: [
    { required: true, message: 'Пожалуйста, введите тип', trigger: 'change', type: 'number' }
  ],
};
const jobRules = {
  organisation: [
    { required: true, message: 'Пожалуйста, введите организацию', trigger: 'blur' }
  ],
  position: [
    { required: true, message: 'Пожалуйста, введите должность', trigger: 'blur' }
  ],
  country: [
    { required: true, message: 'Пожалуйста, введите страну', trigger: 'change' }
  ],
  dateStart: []
};
export default {
  getRules() {
    return rules;
  },
  getEducationRules() {
    return educationRules;
  },
  getJobRules() {
    return jobRules;
  }
}



// WEBPACK FOOTER //
// ./src/api/rules/resume.js